import { profile, axiosConfig } from 'api';

export interface Guest {
  id?: string;
  userId?: string;
  name: string;
  lastName: string;
  gender: 'Male' | 'Female';
  birthDate: string;
  country: string;
  phoneNumber: string;
  email: string;
  documentNumber: string;
  passportNumber?: string;
  userGroupId: string;
  birthDate_day?: string;
  birthDate_month?: string;
  birthDate_year?: string;
  userGroupName?: string;
}

export const createUserGuest = async (guest: Guest): Promise<Guest> => {
  try {
    const response = await profile.post('Users/CreateGuestUser', { ...guest, type: 'invited' }, axiosConfig);
    return response.data.data;
  } catch (error) {
    throw error;
  }
};
